export default __webpack_public_path__ + "static/media/file5.9899c790.png";